import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Tabs from './../Tabs';
import Intersection from './../Intersection';
import {
  getInitalSearchResults,
  performSearch,
  setUrlParams,
} from './../../slices/appSlice';
import queryString from 'query-string';
import history from 'history/browser';

function App() {
  const dispatch = useDispatch();
  const {
    lists,
    selectedIndex,
  } = useSelector((state) => state.app);
  const inViewHelper = useRef(new Array(lists.length).fill([1]));
  const currentParams = queryString.parse(history.location.search);
  const { pages = [], urlParams = {}, loading = false, maxPages = 1, id, banner = [] } = lists[selectedIndex];
  const [currentPage, setCurrentPage] = useState(1);
  const [hasScrolled, setHasScrolled] = useState(!currentParams['page']);

  const handleInViewChange = ({ inView, page }) => {
    const iof = inViewHelper.current[selectedIndex].indexOf(page);

    if (iof === -1 && inView === true) {
      inViewHelper.current[selectedIndex].unshift(page);
      if (inViewHelper.current[selectedIndex].length > 2) {
        inViewHelper.current[selectedIndex].length = 2;
      }
    } else if (iof > -1 && inView === false) {
      inViewHelper.current[selectedIndex].splice(iof, 1);
    }
    if (inViewHelper.current[selectedIndex].length > 0) {
      const currentPage = Math.min.apply(
        null,
        inViewHelper.current[selectedIndex],
      );

      if (currentPage > 0) {
        if (maxPages >= currentPage) {
          dispatch(performSearch({ page: currentPage + 1 }));
          dispatch(setUrlParams({ remove: currentPage === 1, get: { page: currentPage } }));
          setCurrentPage(currentPage);
        }
      }
    }
  };

  useEffect(() => {
    dispatch(getInitalSearchResults());
  }, []);

  useEffect(() => {
    if (currentParams['page']) {
      const pageEle = document.getElementById('product-listing-' + id + '-page-' + currentParams['page']);
      if (pageEle && !hasScrolled) {
        pageEle.scrollIntoView(false);
        setHasScrolled(true);
      }
    }
  }, [pages]);

  return (
    <ft-section spacing="none" width="full">
      <Tabs {...{ lists, selectedIndex, maxPages, currentPage, listId: id }}>
        <ft-section content-padding="none">
          <div className="container container-default pt-5xl pb-5xl">
            {
              pages.map((page, p) => {
                const pageBanner = banner[p];

                return (
                  <Intersection key={`${p}`}
                                page={p + 1} {...{ handleInViewChange, listId: id }}>
                    <If condition={pageBanner}>
                      <div className="banner">
                        <Choose>
                          <When condition={pageBanner.url}>
                            <a href={pageBanner.url}>
                              <picture>
                                <source
                                  srcSet={pageBanner.desktop_image_path}
                                  media="(min-width: 500px)"
                                />
                                <img
                                  src={pageBanner.mobile_image_path}
                                  alt={pageBanner.mobile_image_alt}
                                />
                              </picture>
                            </a>
                          </When>
                          <Otherwise>
                            <picture>
                              <source
                                srcset={pageBanner.desktop_image_path}
                                media="(min-width: 500px)"
                              />
                              <img
                                src={pageBanner.mobile_image_path}
                                alt={pageBanner.mobile_image_alt}
                              />
                            </picture>
                          </Otherwise>
                        </Choose>
                      </div>
                    </If>
                    {
                      page.map(({ _source: { teaser } }, r) => (
                        <div key={`${p}${r}`}
                             dangerouslySetInnerHTML={{ __html: teaser }}></div>
                      ))
                    }
                  </Intersection>
                );
              })
            }
            {
              loading ? <ft-spinner class="absolute left-1/2"></ft-spinner> : ''
            }
          </div>
        </ft-section>
      </Tabs>
    </ft-section>
  );
}

export default App;
